import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { selectStateData } from 'src/core/redux/selectors';
import { addDetails as addDetailsAction } from 'src/actions';
import {
  POOLED_PLATE_VOLUME,
  POOLED_PLATE_NAME,
  POOLED_PLATE_NAME_VALUE,
  POOLED_PLATES,
  PLATES_FOR_POOLING,
  PLATE_POOLING_NAMESPACE,
  PLATE_POOLING_NAMESPACE_ACTION,
} from 'src/constants/forms';

import PlatePoolingCustomComponent from './PlatePoolingCustomComponent';

const POOLED_PLATE_MIN_LENGTH_VALUE = 7;
const PLATES_FOR_POOLING_MIN_LENGTH_VALUE = 8;

const getPooledPlateName = (
  name,
  firstPlate,
  secondPlate,
  volume
) => `${name} (${firstPlate} / ${secondPlate} - ${volume})`;

const PlatePoolingCustomContainer = ({ formData, addFormData }) => {
  const [checkedPoolingPlates, setCheckedPoolingPlates] = React.useState([]);
  const [checkedPooledPlates, setCheckedPooledPlates] = React.useState([]);
  const platesForPooling = formData?.[PLATES_FOR_POOLING]?.value || [];
  const pooledPlates = formData?.[POOLED_PLATES]?.value || [];
  const pooledPlateName = formData?.[POOLED_PLATE_NAME]?.value;
  const pooledPlateVolume = formData?.[POOLED_PLATE_VOLUME]?.value;
  const showPooledscrollBar = pooledPlates.length > POOLED_PLATE_MIN_LENGTH_VALUE;
  const showPoolingScrollBar = platesForPooling.length > PLATES_FOR_POOLING_MIN_LENGTH_VALUE;
  const disableAddButton = !(
    formData?.[POOLED_PLATE_NAME]?.isValid &&
    formData?.[POOLED_PLATE_VOLUME]?.isValid &&
    checkedPoolingPlates.length > 1);

  const onCheckPlates = (value, type) => {
    switch (type) {
      case PLATES_FOR_POOLING:
        if (checkedPoolingPlates.indexOf(value) !== -1) {
          setCheckedPoolingPlates(
            checkedPoolingPlates.filter((checkedPlate) => checkedPlate !== value)
          );
        } else {
          setCheckedPoolingPlates([...checkedPoolingPlates, value]);
        }
        break;

      case POOLED_PLATES:
        if (checkedPooledPlates.indexOf(value) !== -1) {
          setCheckedPooledPlates(
            checkedPooledPlates.filter((checkedPlate) => checkedPlate !== value)
          );
        } else {
          setCheckedPooledPlates([...checkedPooledPlates, value]);
        }
        break;

      default:
    }
  };

  const onAdd = () => {
    const newPooledPlate = [
      ...pooledPlates,
      {
        name: getPooledPlateName(
          pooledPlateName,
          platesForPooling[checkedPoolingPlates[0]].plateName,
          platesForPooling[checkedPoolingPlates[1]].plateName,
          pooledPlateVolume
        ),
        volume: pooledPlateVolume,
        plateList: [
          platesForPooling[checkedPoolingPlates[0]].plateName,
          platesForPooling[checkedPoolingPlates[1]].plateName,
        ],
      },
    ];

    setCheckedPoolingPlates([]);

    const newPlatesForPooling = platesForPooling.filter(
      (item) => item.plateName !==
          platesForPooling[checkedPoolingPlates[0]].plateName &&
        item.plateName !== platesForPooling[checkedPoolingPlates[1]].plateName
    );

    addFormData({
      ...formData,
      [PLATES_FOR_POOLING]: { value: newPlatesForPooling, isValid: true },
      [POOLED_PLATES]: { value: newPooledPlate, isValid: true },
      [POOLED_PLATE_NAME]: { value: POOLED_PLATE_NAME_VALUE, isValid: true },
    });
  };

  const onRemove = () => {
    let newPlatesForPooling = [];
    let newPooledPlates = [];

    checkedPooledPlates.forEach((el) => {
      newPlatesForPooling.push(
        {
          plateName: pooledPlates[el].plateList[0],
          isValid: true,
          errors: [],
        },
        {
          plateName: pooledPlates[el].plateList[1],
          isValid: true,
          errors: [],
        }
      );
    });

    newPlatesForPooling = [...platesForPooling, ...newPlatesForPooling];
    newPooledPlates = pooledPlates.filter(
      (pooledPlate) => !newPlatesForPooling.find(
        (newPlateForPooling) => pooledPlate?.plateList[0] === newPlateForPooling?.plateName ||
            pooledPlate?.plateList[1] === newPlateForPooling?.plateName
      )
    );
    setCheckedPooledPlates([]);
    setCheckedPoolingPlates([]);

    addFormData({
      ...formData,
      [PLATES_FOR_POOLING]: {
        value: newPlatesForPooling,
        isValid: true,
      },
      [POOLED_PLATES]: { value: newPooledPlates, isValid: true },
    });
  };

  return (
    <PlatePoolingCustomComponent
      {...{
        onCheckPlates,
        onAdd,
        onRemove,
        showPoolingScrollBar,
        showPooledscrollBar,
        disableAddButton,
        disableRemoveButton: !checkedPooledPlates.length,
        platesForPooling,
        pooledPlates,
        checkedPoolingPlates,
        checkedPooledPlates,
      }}
    />
  );
};

PlatePoolingCustomContainer.propTypes = {
  formData: PropTypes.object,
  addFormData: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  formData: selectStateData(PLATE_POOLING_NAMESPACE)(state),
});

const mapDispatchToProps = {
  addFormData: addDetailsAction(PLATE_POOLING_NAMESPACE_ACTION),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PlatePoolingCustomContainer);
